import { useQuery } from "@tanstack/react-query";
import { Button, Spin } from "antd";
import { useState } from "react";
import { useIntl } from "react-intl";
import { useSelector } from "react-redux";
import { EditSVG } from "../../../assets/SVGs/SVGs";
import { getSalon } from "../../../network/settings";
import { queryKeys } from "../../../services/react-query/queryKeys";
import EditSalonData from "./components/EditSalonData";
import ShowSalonData from "./components/ShowSalonData";
type Props = {};

const AboutSalon = (props: Props) => {
  const currentUser = useSelector((s: any) => s?.user?.data);
  const [isEdit, setIsEdit] = useState(false);
  console.log(currentUser?.user);
  const { id } = currentUser?.user?.salon;
  const { phone } = currentUser?.user;
  const { data, isLoading } = useQuery([queryKeys?.listSalon], () =>
    getSalon(id, true)
  );
  const intl = useIntl();
  const { locale } = intl;
  const localeName = data?.data.name[locale];
  const { email, website_url, name } = data?.data || {};

  return (
    <div className={`bg-[#EEF0FF] rounded-b-lg p-6`}>
      <div className={` ${isEdit && "bg-[#FBFBFF]"} px-4 py-4 pb-8 rounded-lg`}>
        <Button
          onClick={() => setIsEdit((e) => !e)}
          style={{ background: isEdit ? "#FBFBFF" : "#EEF0FF" }}
          className="flex items-center justify-end w-full border-none"
        >
          {EditSVG}
        </Button>
        {isLoading ? (
          <Spin className="flex items-center justify-center w-full" />
        ) : isEdit ? (
          <EditSalonData
            close={setIsEdit}
            email={email}
            name={name}
            phone={phone}
            website={website_url}
            salonId={currentUser?.user?.salon?.id}
          />
        ) : (
          <ShowSalonData
            email={data?.data.email}
            name={localeName}
            phone={phone}
            site={website_url}
          />
        )}
      </div>
    </div>
  );
};

export default AboutSalon;
